import { render, staticRenderFns } from "./SummaryByProject.vue?vue&type=template&id=15baaf66"
import script from "./SummaryByProject.vue?vue&type=script&lang=js"
export * from "./SummaryByProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports